import React, { useState, useContext, useEffect, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';

import metadata from './MLVoidPaymentPopup.metadata.json5';
import styles from './MLVoidPaymentPopup.module.scss';
import messages from './MLVoidPaymentPopup.messages'

const MLVoidPaymentPopup = (props) => {
    const {
        onSave,
        onCancel,
        isBundle,
        confirmationNumber
    } = props;

    const translator = useTranslator();

    const overrideProps = {
        voidPaymentPopupHeader: {
            className: styles.modalHeader
        },
        voidPaymentPopupBody: {
            className: styles.modalBody
        },
        alertGroupPopup: {
            className: `${styles.alertNotificationStyling} vertical-spacing-30`
        },
        warningInlineNotification: {
            message: translator(messages.voidingThisTransaction)
        },
        bundlePaymentWarning: {
            visible: isBundle,
            message: <FormattedMessage
                    {...messages.bundlePaymentMessage}
                    values={{
                        confirmationNumber: confirmationNumber
                    }}
                />            
        },
        closeButton: {
            content: translator(messages.cancel),
            className: styles.cancelBtn
        },
        saveButton: {
            content: translator(messages.continue)
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onCancel,
            onSave
        },
        resolveComponentMap: {
            MLAlertGroupComponent
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={styles}
        />
    );
}


MLVoidPaymentPopup.propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    payment: PropTypes.shape({})
}

export default MLVoidPaymentPopup;
